import { PaletteOptions } from '@mui/material/styles';

import { darkPalette } from './darkPalette';

export const darkPaletteBlockRail = {
  ...darkPalette,

  mode: 'dark',

  primary: {
    ...darkPalette.primary,
    main: darkPalette.indigo.main,
    dark: darkPalette.indigo.dark,
  },

  info: {
    ...darkPalette.info,
    // contrastText:
  },

  // link: {
  //   ...darkPalette.link,
  //   // main:
  // },
} satisfies PaletteOptions;
